import { render, staticRenderFns } from "./AstuceModal.vue?vue&type=template&id=6b77503e"
import script from "./AstuceModal.vue?vue&type=script&lang=js"
export * from "./AstuceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports